import { Stack, StackTypeMap, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

import { TypingIndicator } from '~/components/TypingIndicator/TypingIndicator';

export type LoaderVariantType = 'start' | 'end' | 'none';

interface ChatMessageProps {
  loaderVariant: LoaderVariantType;
}

export const ChatMessage = ({ children, loaderVariant = 'none' }: PropsWithChildren<ChatMessageProps>) => {
  if (typeof children === 'object') {
    return <>{children}</>;
  }

  if (loaderVariant === 'none') {
    return (
      <Typography
        sx={{
          paddingBottom: 2,
        }}
      >
        {children}
      </Typography>
    );
  }

  const direction: StackTypeMap['props']['direction'] = loaderVariant === 'start' ? 'row' : 'row-reverse';
  const justifyContent: StackTypeMap['props']['justifyContent'] = loaderVariant === 'start' ? 'flex-start' : 'flex-end';

  return (
    <Stack
      spacing={2}
      direction={direction}
      sx={{
        justifyContent: justifyContent,
        alignItems: 'center',
      }}
    >
      <TypingIndicator />
      <Typography>{children}</Typography>
    </Stack>
  );
};
